import { type ComponentType, type ReactNode } from 'react'
import { webviewNavigation } from 'shared/page-enhancers'

import { useDeusExMachina } from '~/domains/platform/infra/deus-ex-machina/hocs/with-deus-ex-machina'

import { useExperiment } from '../hooks/use-experiment'

export const withExperimentGuard = <P extends Record<string, unknown>>(
  Component: ComponentType<P>,
  flagKey: string,
  fallback: ReactNode = null
) => {
  function ExperimentGuardPage(props: P) {
    const { deusExMachina } = useDeusExMachina()
    const { isFeatureFlagEnabled, isLoading } = useExperiment(deusExMachina?.subject.id ?? '', flagKey)

    if (isLoading) return fallback

    if (!isFeatureFlagEnabled) {
      webviewNavigation.navigateTo('/404')
      return fallback
    }

    return <Component {...props} />
  }

  ExperimentGuardPage.displayName = `withExperimentGuard(${Component.displayName ?? Component.name})`
  return ExperimentGuardPage
}
